export default __webpack_public_path__ + "static/media/logo-text.54463712.png";